// src/app/project-bid-grid/project-bid-grid.component.ts
import { Component, OnInit } from '@angular/core';
import { ProjectBidService } from '../Services/projectbid.service';
import { Router } from '@angular/router';
import { ProjectBid } from '../objects/ProjectBid';

@Component({
  selector: 'app-project-bid-grid',
  templateUrl: './project-bid-grid.component.html',
  styleUrls: ['./project-bid-grid.component.css'],
})
export class ProjectBidGridComponent implements OnInit {
  projectBids: ProjectBid[] = [];
  searchTerm = '';
  isMobile = false;

  constructor(
    private projectBidService: ProjectBidService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadProjectBids();
    this.checkIsMobile();
  }

  loadProjectBids() {
    this.projectBidService.getProjectBids().subscribe((projectBids) => {
      this.projectBids = projectBids;
    });
  }

  checkIsMobile() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.isMobile = width < 768;
  }

  get filteredProjectBids(): ProjectBid[] {
    if (!this.searchTerm.trim()) return this.projectBids;
    const term = this.searchTerm.toLowerCase();
    return this.projectBids.filter(b =>
      b.companyName?.toLowerCase().includes(term) ||
      b.projectDetails?.toLowerCase().includes(term) ||
      b.projectType?.type?.toLowerCase().includes(term) ||
      b.status?.toLowerCase().includes(term) ||
      (b.contractor as any)?.name?.toLowerCase().includes(term)
    );
  }

  getStatusClass(status: string): string {
    const s = (status || '').toLowerCase();
    if (s.includes('pending')) return 'badge-pending';
    if (s.includes('approv') || s.includes('won') || s.includes('accept')) return 'badge-approved';
    if (s.includes('reject') || s.includes('lost') || s.includes('declin')) return 'badge-rejected';
    if (s.includes('submit')) return 'badge-submitted';
    return 'badge-default';
  }

  editProjectBid(projectBid: ProjectBid) {
    this.router.navigate(['project-bids/edit/', projectBid.id]);
  }
}
